<template>
    <article class="tile is-child card">
        <header class="card-header">
            <p class="title">Projects</p>
            <a
                v-if="canStoreProject"
                :href="route('projects.create', { account_id: accountId })"
                class="card-header-icon"
            >Add</a>
        </header>
        <div class="content">
            <p class="panel-tabs">
                <a
                    :class="{ 'is-active': isFiltering('active') }"
                    @click="filterAs('active')"
                >Active</a>

                <a
                    :class="{ 'is-active': isFiltering('completed') }"
                    @click="filterAs('completed')"
                >Completed</a>

                <a
                    :class="{ 'is-active': isFiltering('all') }"
                    @click="filterAs('all')"
                >All</a>
            </p>
            <div v-if="loading" class="centered loader is-medium"></div>
            <div v-else-if="isNotEmpty" class="content-holder scrollbox pt0">
                <div class="filter-list">
                    <a
                        v-for="project in filteredProjects"
                        :key="project.id"
                        :href="route('projects.show', { project: project.id })"
                        :class="{
                            'panel-block': true,
                            'is-medium': true,
                        }"
                    >
                        <span v-text="project.name"></span>
                    </a>
                </div>
            </div>
            <div class="notification" v-else>
                <p>{{ trans('app.project.none') }}</p>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        accountId: {
            type: Number,
            required: true,
        },
        userId: {
            type: Number,
            required: false,
            default: null,
        },
        canStoreProject: {
            type: Boolean,
            default: false,
        },
    },

    data () {
        return {
            loading: true,
            activeFilter: 'active',
            projects: [],
        };
    },

    computed: {
        isNotEmpty () {
            return ! _.isEmpty(this.projects);
        },

        filteredProjects () {
            if (this.activeFilter === 'active') {
                return _.filter(this.projects, project =>
                    this.isProjectActive(project)
                );
            }

            if (this.activeFilter === 'completed') {
                return _.filter(
                    this.projects,
                    project => ! this.isProjectActive(project)
                );
            }

            if (this.activeFilter === 'all') {
                return this.projects;
            }

            return [];
        },
    },

    listeners: {
        async 'project-updated' () {
            await this.fetchList();
        },
    },

    methods: {
        filterAs (filter) {
            this.activeFilter = filter;
        },

        isFiltering (filter) {
            return this.activeFilter === filter;
        },

        isProjectActive (project) {
            return _.isNull(project.end_date);
        },

        async fetchList () {
            try {
                this.loading = true;
                let { data } = await axios.get(
                    this.route('projects.list', {
                        account_id: this.accountId,
                        my_projects: 1,
                    })
                );

                this.projects = data.projects;
            } catch (errors) {
                console.error(errors);
            } finally {
                this.loading = false;
            }
        },
    },

    async created () {
        await this.fetchList();
    },
};
</script>
